<template>
  <div>
    <img :src="statusIcon[status]" height="12" />
            {{ status | taskStatusCn }}
  </div>
</template>
<script>
import green from "@/assets/images/user/green.svg";
import blue from "@/assets/images/user/blue.svg";
import red from "@/assets/images/user/red.svg";
import gray from "@/assets/images/user/gray.svg";
import yellow from "@/assets/images/user/yellow.svg";
import purple from "@/assets/images/user/purple.svg";
import darkgreen from "@/assets/images/user/darkgreen.svg";
export default {
 data() {
  return {
    statusIcon: {
        created: gray,
        started: blue,
        ended: blue,
        uploaded: blue,
        confirmed: green,
        appealing: yellow,
        appealed: red,
        completed: green,
        reviewing: purple,
        reviewed: darkgreen,
      },
  }
 },
 methods: {},
 components: {},
 props: {
  status: {
    type: String,
    default: "",
  },
 }
}
</script>
<style>
</style>